
import React, { createContext, useReducer, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast'; 


export const CartContext = createContext();


const ADD_TO_CART = 'ADD_TO_CART';
const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
const CLEAR_CART = 'CLEAR_CART';
const UPDATE_QUANTITY = 'UPDATE_QUANTITY'; 


const cartReducer = (state, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      console.log(`CartContext: Добавляем товар в корзину: ${action.payload.product.title}, количество: ${action.payload.quantity}`);
      const existingProduct = state.find(item => item.id === action.payload.product.id);
      if (existingProduct) {
        console.log('CartContext: Товар уже существует. Обновляем количество.');
        return state.map(item =>
          item.id === action.payload.product.id
            ? { ...item, quantity: item.quantity + action.payload.quantity }
            : item
        );
      } else {
        console.log('CartContext: Товар новый. Добавляем в корзину.');
        return [...state, { ...action.payload.product, quantity: action.payload.quantity }];
      }

    case REMOVE_FROM_CART:
      console.log(`CartContext: Удаляем товар из корзины. ID: ${action.payload}`);
      return state.filter(item => item.id !== action.payload);

    case CLEAR_CART:
      console.log('CartContext: Очищаем корзину.');
      return [];

    case UPDATE_QUANTITY:
      console.log(`CartContext: Обновляем количество товара. ID: ${action.payload.id}, Новое количество: ${action.payload.quantity}`);
      return state.map(item =>
        item.id === action.payload.id
          ? { ...item, quantity: action.payload.quantity }
          : item
      );

    default:
      return state;
  }
};


const initializeCart = () => {
  const storedCart = localStorage.getItem('cart');
  console.log('CartContext: Загружаем корзину из localStorage:', storedCart);
  if (storedCart) {
    try {
      const parsedCart = JSON.parse(storedCart);
      console.log('CartContext: Корзина успешно загружена:', parsedCart);
      return parsedCart;
    } catch (error) {
      console.error('CartContext: Ошибка при парсинге корзины из localStorage:', error);
      return [];
    }
  }
  return [];
};


export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, [], initializeCart);

  
  useEffect(() => {
    console.log('CartContext: Сохраняем корзину в localStorage:', cart);
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  
  const addToCart = (product, quantity) => {
    dispatch({ type: ADD_TO_CART, payload: { product, quantity } });
  };

  const removeFromCart = (productId) => {
    dispatch({ type: REMOVE_FROM_CART, payload: productId });
  };

  const clearCart = () => {
    dispatch({ type: CLEAR_CART });
  };

  const updateQuantity = (productId, newQuantity) => { 
    if (newQuantity < 1) {
      toast.error('Количество должно быть хотя бы 1.');
      return;
    }
    dispatch({ type: UPDATE_QUANTITY, payload: { id: productId, quantity: newQuantity } });
  };

  
  const uniqueItemsCount = cart.length;

  
  const contextValue = useMemo(() => ({
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    updateQuantity, 
    uniqueItemsCount,
  }), [cart, uniqueItemsCount]);

  return (
    <CartContext.Provider value={contextValue}>
      {children}
    </CartContext.Provider>
  );
};
